import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Box, Button, Grid, Grow, Paper, Typography } from '@mui/material'
import { createTheme } from '@mui/material/styles'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import QuilityLevelTerm from '../images/Quility-Level-Term_Logo.svg'
import ForestersLandingLogo from '../images/foresters_landing_logo.svg'
import SBLILogo from '../images/sbli-logo.png'
import { AuthContext } from '../libs/contexts/authContext'
import QLTSecureFutureSelct from '../images/Quility-Secure-Future-Select_Logo.svg'
// import { useMediaQuery } from '@mui/material';

const defaultTheme = createTheme()

const LandingPageV2 = ({ toggleDrawer, ...props }) => {
  const { getAgentProduct, getAffiliateLoginInfo, productArray } = props
  // const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down("sm"));
  const { affiliateCode } = useContext(AuthContext)
  const [greyTermLife, setGreyTermLife] = useState(true)
  //   const [greyFinalExpense, setGreyFinalExpense] = useState(true)
  //   const [portalFlag, setPortalFlag] = useState(null)
  //   const [qltProduct, setQltProduct] = useState(null)
  //   const [feProduct, setFeProduct] = useState(null)
  const navigate = useNavigate()
  //   const { search } = useLocation()
  //   const productIds = useMemo(() => productArray.map((p) => p.productId), [productArray])

  //   useEffect(() => {
  //     const data = {
  //       affiliateCode,
  //     }
  //     getAgentProduct(data)
  //     getAffiliateLoginInfo(data)
  //   }, [affiliateCode, getAffiliateLoginInfo, getAgentProduct])

  // useEffect(() => {
  //   const data = {
  //     affiliateCode,
  //   }
  //   getAffiliateLoginInfo(data)
  // }, [affiliateCode, getAffiliateLoginInfo])

  // useEffect(() => {
  //   const data = {
  //     affiliateCode,
  //   };
  //   props.getAffiliateLoginInfo(data)
  //   console.log("called")
  // },[])
  //   useEffect(() => {
  //     if (productArray[0]) {
  //       setPortalFlag(productArray[0]?.portalFlag)
  //       if (productIds.includes('8140') || productIds.includes('81401')) {
  //         const qlt = productArray.find((product) => product.productId === '8140' || product.productId === '81401')
  //         setQltProduct(qlt)
  //       }
  //       if (productIds.includes('8118')) {
  //         const fe = productArray.find((product) => product.productId === '8118')
  //         setFeProduct(fe)
  //       }
  //     }
  //   }, [productArray])

  // useEffect(() => {
  //   console.log('entered', portalFlag, !props.isAuthenticated)
  //   if (portalFlag === 0 && !props.isAuthenticated) {
  //     const qltProductObj = productArray.find(
  //       (product) => product.productId === '8140' || product.productId === '81401'
  //     )
  //     window.open(`${qltProductObj.productUrl}`, '_blank')
  //   }
  // }, [portalFlag])

  //   useEffect(() => {
  //     if (productIds.includes('8118')) {
  //       setGreyFinalExpense(false)
  //     }
  //     if (
  //       productIds.includes('8140') ||
  //       productIds.includes('8142') ||
  //       productIds.includes('81401') ||
  //       productIds.includes('81420')
  //     ) {
  //       setGreyTermLife(false)
  //     }
  //   }, [productIds])

  //   const handleQLTSubmit = async () => {
  //     if (props.isAuthenticated) {
  //       window.open(`${qltProduct.productUrl}`, '_blank')
  //     }

  //     if (props.redirect === 'otp' || props.redirect === 'login-exists') {
  //       navigate(`/login/${search}`)
  //     } else {
  //       window.open(`${qltProduct.productUrl}`, '_blank')
  //     }
  //   }

  //   const handleFESubmit = async () => {
  //     if (props.isAuthenticated) {
  //       window.open(`${feProduct.productUrl}`, '_blank')
  //     }
  //     if (props.redirect === 'otp' || props.redirect === 'login-exists') {
  //       navigate(`/login/${search}`)
  //     } else {
  //       window.open(`${feProduct.productUrl}`, '_blank')
  //     }
  //   }
  const currentLocation = window.location.href
  const newAppLink =
    currentLocation.includes('test') || currentLocation.includes('localhost')
      ? `https://eapp-qa.afficiency.com/?productId=4127&distributorId=8973&affiliateCode=${affiliateCode}&channel=DFL`
      : currentLocation.includes('demo')?
      `https://eapp-demo.afficiency.com/?productId=4127&distributorId=8973&affiliateCode=${affiliateCode}&channel=DFL`
      :`https://lifeeapp.afficiency.com/?productId=4127&distributorId=8973&affiliateCode=${affiliateCode}&channel=DFL`
  return (
    // <div style={{ backgroundColor: '#F7F8FC', fontFamily: 'Roboto', minHeight: '100vh' }}>
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={{ minHeight: '100vh', backgroundColor: '#F7F8FC', maxWidth: '100vw', overflow: 'hidden' }}
    >
      <Grid item xs={12} sm={10} md={8}>
        <Typography variant="h1" style={{ padding: '50px 0px 70px 20px', fontSize: '36px' }}>
          Get a Life Insurance Policy within Minutes
        </Typography>
        <Grid container justifyContent={'center'} alignItems={'center'}>
          <Grid item xs={12} lg={7} md={9}>
            <Grow in={true} timeout={1000}>
              <Paper
                variant={greyTermLife ? 'outlined' : 'elevation'}
                style={{
                  borderRadius: '10px',
                  position: 'relative',
                  height: '500px',
                  width: { lg: '45%', md: '70%', sm: '80%', xs: '50%' },
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: '#fff',
                  color: defaultTheme.palette.primary.main,
                  padding: '0 20px',
                  gap: '3.5rem',
                  boxShadow: '0px 4px 20px -4px #10182814',
                  border: 'none',
                }}
              >
                <Box
                  component="img"
                  src={ForestersLandingLogo}
                  sx={{
                    width: '83%',
                    padding: 'auto 100px',
                    opacity: 1,
                  }}
                />
                {false ? (
                  <Typography display="flex" alignItems={'center'} justifyContent={'center'} color="#3C4FB9">
                    {' '}
                    <InfoOutlinedIcon sx={{ margin: '8px', color: '#3C4FB9' }} />
                    Not Available
                  </Typography>
                ) : (
                  <Button
                    //   onClick={
                    //     handleQLTSubmit
                    //     }
                    sx={homeStyle.updateInfoButton}
                    onClick={() => window.open(newAppLink, '_blank')}
                  >
                    {/* <Typography sx={homeStyle.updateInfoText}> */}
                   Start Illustration/Application
                    {/* </Typography> */}
                  </Button>
                )}
              </Paper>
            </Grow>
          </Grid>
        </Grid>
        {/* <Grid container justifyContent="center" alignItems="center">
          <Grid
            item
            sm={12}
            md={12}
            lg={12}
            display="flex"
            flexDirection={'row'}
            alignItems={'center'}
            justifyContent={'center'}
            paddingTop="15px"
            paddingRight="25px"
          >
            <Button>
              <Typography
                textTransform={'none'}
                sx={{
                  textDecoration: 'underline',
                  textUnderlineOffset: '2px',
                }}
              >
                {' '}
                <a href="https://www.afficiency.com/terms-of-service" target="_blank" rel="noopener noreferrer">
                  Terms of Service
                </a>{' '}
              </Typography>
            </Button>

            <Typography>and</Typography>
            <Button>
              <Typography
                textTransform={'none'}
                sx={{
                  textDecoration: 'underline',
                  textUnderlineOffset: '2px',
                }}
              >
                {' '}
                <a href="https://www.afficiency.com/privacy-policy" target="_blank" rel="noopener noreferrer">
                  Privacy Policy
                </a>{' '}
              </Typography>
            </Button>
          </Grid>
        </Grid> */}
      </Grid>
    </Grid>
    // </div>
  )
}

export default LandingPageV2

const homeStyle = {
  updateInfoText: {
    color: '#fff',
    fontFamily: 'Roboto',
    fontStyle: 'bold',
    fontWeight: 800,
    fontSize: '14px',
    lineHeight: '20px',
    textAlign: 'center',
    letterSpacing: '0.1px',
  },

  updateInfoButton: {
    fontFamily: 'Roboto',
    fontStyle: 'bold',
    fontWeight: 800,
    fontSize: '14px',
    lineHeight: '20px',
    textAlign: 'center',
    letterSpacing: '0.1px',
    justifyContent: 'center',
    textTransform: 'none',
    // py: '10px',
    width: '229px',
    height: '40px',
    // mt: '15px',
    backgroundColor: '#3C4FB9',
    color: '#fff',
    borderRadius: '100px',
    border: '1px solid #3C4FB9',
    '&:hover': {
      backgroundColor: '#FFFFFF',
      color: '#3C4FB9',
    },
    '&.Mui-disabled': {
      backgroundColor: '#DDDDDD',
      color: '#fff',
      textTransform: 'none',
    },
  },

  container: (theme) => ({
    display: 'flex',
  }),
  item: (theme) => ({
    border: '1px solid blue',
  }),
  itemFlexGrow: (theme) => ({
    flexGrow: 1,
    border: '1px solid red',
  }),
}
